import React, { ReactNode, useRef, useEffect, useState } from "react";

export interface FadeSectionProps {
	children: ReactNode;
	className?: string;
	fade?: boolean;
}

const FadeSection: React.FC<FadeSectionProps> = ({ children, className, fade = false }) => {
	const fadeContainer: any = useRef(null);
	const [useTransition, setUseTransition] = useState(false);

	useEffect(() => {
		setUseTransition(true);
	}, [fade]);

	return (
		<div
			className={`fade-section fade-section-container ${useTransition ? "transition" : ""} ${className} ${
				fade ? "show" : "mask"
			}`}
			ref={fadeContainer}
			aria-hidden={fade ? undefined : "true"}
		>
			<div
				className={`fade-section ${className} ${fade ? "show" : "mask"}`}
				style={{ display: fade ? undefined : "none" }}
			>
				{children}
			</div>
		</div>
	);
};

export default FadeSection;
